
































import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {},
})
export default class Home extends Vue {
  public activeMenu = "";
  // public mounted() {}
  public goto(i) {
    this.$router.push({
      path: "/agreement",
      query: {
        type: i,
      },
    });
  }
  public tobeian() {
    window.open("https://beian.miit.gov.cn/#/Integrated/index");
  }
}
